import type { IAmericanCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/AmericanCompanyIssuerTopLevel.generated";
import { createContext } from "react";

const AmericanCompanyContext = createContext<IAmericanCompanyIssuerTopLevelFragment | null>(null);

export default AmericanCompanyContext;
